const sc =  ({page, c, ...options}) => {
    let params = {
        $title: page || document.title,
        section_name: page,
        module_name: c,
        title: 'medilink_click',
        ...options
    }
    const { title, ...trackOptions } = params;
    sensors.track(title, {
        platform_name: "medilink",
        ...trackOptions
    });
}
export default {
    sc
}